var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Logger Module","items":_vm.logNames},model:{value:(_vm.moduleToConfigure),callback:function ($$v) {_vm.moduleToConfigure=$$v},expression:"moduleToConfigure"}})
}
var staticRenderFns = []

export { render, staticRenderFns }